import axios from "axios"
// import { history } from "../.."
import { CustomLogger, getMeetingUrl, getToken, VERSION_NO } from "./utils.actions"
import moment from "moment"
import * as Actions from "./index"
export const LOGIN_ATTEMPT = "LOGIN_ATTEMPT"
export const LOGOUT_ACTION = "LOGOUT_ACTION"
export const HISTORY_DATA_GET = "HISTORY_DATA_GET"
export const SAVE_PERMISSIONS = "SAVE_PERMISSIONS"
export const DATA_FOR_ADD_PATIENTS = "DATA_FOR_ADD_PATIENTS"
export const GETTING_STATES = "GETTING_STATES"
export const EDIT_PATIENT = "EDIT_PATIENT"
export const BILLING_DIALOG_DATA = "BILLING_DIALOG_DATA"
export const BOOKING_LIST = "BOOKING_LIST"
export const VERIFY_DATA = "VERIFY_DATA"
export const UPDATE_PHOTO = "UPDATE_PHOTO"
export const SET_IS_AUTH = "SET_IS_AUTH"
export const SET_IS_HOST = "SET_IS_HOST"


export const LoginProviderAction = (email, password) => async (dispatch, getState) => {
    try {

        if (!email) return "Please Enter Email"

        if (!email.match(/([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)) return "Please Enter Valid Email"

        if (!password) return "Please Enter Password"



        const body = [
            {
                "email": email,
                "deviceTypeId": 6,
                "deviceUDID": "Computer",
                "password": password,
                "type": "AdminDoctor",
                "createRoom": 0,
                "createDefaultRoom": 1
            }
        ]

        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/LoginProvider`, body);

        return res.data;

    } catch (error) {
        console.error(error?.response?.data?.error?.message)
        return error?.response?.data?.error?.message ? "Warning: Account has been locked. Please try again after 30 minutes." : "Something failed, Try again later"
    }
}

export const MFACheckAction = (email, password, rID, adminDocterId,) => async (dispatch, getState) => {
    try {

        if (!email) return "Please Enter Email"

        if (!email.match(/([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)) return "Please Enter Valid Email"

        if (!password) return "Please Enter Password"

        const body = [
            {
                "email": email,
                "deviceTypeId": 6,
                "deviceUDID": "Computer",
                "password": password,
                "type": "AdminDoctor",
                "createRoom": 0,
                "createDefaultRoom": 1,
                clinicGroupItemId: rID,
                adminDocterId,
            }
        ]

        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/MFACheckPoint`, body);

        return res.data;

    } catch (error) {
        console.error(error)
        return error?.response?.data?.error?.message ? "Warning: Account has been locked. Please try again after 30 minutes." : "Something failed, Try again later"
    }
}

export const LoginAction = (email, password, rID, adminDocterId, MultiCode, navigate) => async (dispatch, getState) => {

    try {

        if (!email) return "Please Enter Email"

        if (!email.match(/([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)) return "Please Enter Valid Email"

        if (!password) return "Please Enter Password"

        const body = [
            {
                "email": email,
                "deviceTypeId": 6,
                "deviceUDID": "Computer",
                "password": password,
                "type": "AdminDoctor",
                "createRoom": 0,
                "createDefaultRoom": 1,
                clinicGroupItemId: rID,
                adminDocterId,
                passcode: MultiCode
            }
        ]
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/Login`, body)

        if (res.data.status == 0) {

            return res.data.msg
        }
        if (res.data.length == 0) return "Invalid Credientials"

        if (res?.data[0]?.isActive == "0") return "Please activate your account before use"
        dispatch({
            type: LOGIN_ATTEMPT,
            payload: res.data[0]
        })

        sessionStorage.setItem("UserData", JSON.stringify(res.data[0]))
        dispatch(GetPermissions(res.data[0]?.isPilotOInstituations, res.data[0]?.ClinicGroupItem, res.data[0]?.ClinicGroupAdminDocterRel))
        navigate("/room")
        return false



    } catch (error) {
        console.error(error)
        return error?.response?.data?.error?.message ? "Warning: Account has been locked. Please try again after 30 minutes." : "Something failed, Try again later"
    }

}

export const CheckingUserData = (data) => async (dispatch, getState) => {
    dispatch({
        type: LOGIN_ATTEMPT,
        payload: data
    })
    dispatch(GetPermissions(data?.isPilotOInstituations, data?.ClinicGroupItem, data?.ClinicGroupAdminDocterRel))

}


export const LogoutAction = () => async (dispatch, getState) => {

    dispatch({
        type: LOGOUT_ACTION
    })
    sessionStorage.clear()
    location.reload()
}


export const ForgetPasswordAction = (email) => async (dispatch, getState) => {



    try {

        if (!email) return "Please Enter Email"

        if (!email.match(/([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)) return "Please Enter Valid Email"



        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/lostPassword?email=` + email)

        if (res.data.status == 0) return res.data.msg;


    } catch (error) {
        return "Something failed, Try again later"
    }
}


export const GettingHistoryData = (filter) => async (dispatch, getState) => {
    try {
        dispatch({
            type: HISTORY_DATA_GET,
            payload: null,
        })


        const body = {
            "startDateStr": moment().startOf('month').format('YYYY-MM-DD hh:mm'),
            "endDateStr": new Date().toUTCString(),
            "adminDocterId": getState().auth.UserData.adminDocterId,
            "doctorIdParam": getState().auth.UserData.adminDocterId,
            "passcode": "health001~ACHJ",
            "token": getToken(getState),
            "currentPage": 1,
            "pageLimit": 10,
            "type": "history",
            "currentDateTime": new Date().toUTCString(),
            "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
            "isFromMeetingServer": 1,
            dateFilter: filter,
        }
        let res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/getMeetingHistory`, body)


        dispatch({
            type: HISTORY_DATA_GET,
            payload: res.data.data
        })
    } catch (error) {
        console.log(error)
    }


}

export const GettingBookingDetails = (SelectedSNF, TabType) => async (dispatch, getState) => {
    try {
        if (!getState().auth?.UserData?.adminDocterId) return
        const body = {
            "startDateStr": "",
            "endDateStr": "",
            "adminDocterId": getState().auth?.UserData?.adminDocterId,
            // "doctorIdParam": getState().auth?.UserData?.adminDocterId,
            // "passcode": "health001~ACHJ",
            // "token": getToken(getState),
            "currentPage": 1,
            "pageLimit": 20,
            "type": "upcoming",
            // "currentDateTime": new Date(),
            "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
            // "isFromMeetingServer": 1,
            "showOvData": 0,
            tabname: TabType,
            // tabname: getState().auth?.UserData?.isSNFPM == 1 ? "snfschedule" : TabType,
            selectedSNFId: TabType === "snfschedule" || getState().auth?.UserData?.isSNFPM == 1 ? SelectedSNF?.clinicGroupItemId : undefined
        }

        dispatch({
            type: BOOKING_LIST,
            payload: []
        })
        let res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/getMeetingHistory`, body);


        dispatch({
            type: BOOKING_LIST,
            payload: res.data.data
        })
    } catch (error) {
        return
    }



}


export const UpdateProfileData = (Email, PhoneNo, FirstName, LastName, Password, ConfirmPassword, ConsentForm,) => async (dispatch, getState) => {


    if (!FirstName) return { status: false, msg: "Please Enter Firstname" }
    if (!LastName) return { status: false, msg: "Please Enter LastName" }
    if (!Email) return { status: false, msg: "Please Enter Email Address" }
    if (!Email.match(/([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)) return "Please Enter Valid Email"
    // if (!PhoneNo) return { status: false, msg: "Please Enter PhoneNo" }

    if (Password && !Password.match(/^(?=.*\d)(?=.*[!@#$%^&*?]).{8,}$/)) return { status: false, msg: "Please follow the password guidelines" }
    if (Password && !ConfirmPassword) return { status: false, msg: "Please Enter Confirm Password" }
    if (Password !== ConfirmPassword) return { status: false, msg: "Password does not match" }


    try {
        const MyForm = new FormData()
        const userTmpData = getState().auth.UserData;

        MyForm.append("adminDocterId", `${getState().auth.UserData.adminDocterId}`);
        MyForm.append("firstname", FirstName);
        MyForm.append("lastname", LastName);
        MyForm.append("pwd", Password);
        MyForm.append("email", Email);
        MyForm.append("cellphone", PhoneNo);
        MyForm.append("clinicGroupItemId", `${getState().auth.UserData.features[0].clinicGroupItemId}`);
        MyForm.append("consentFileInfo", "");
        if (ConsentForm) {
            MyForm.append("consentFileInfo", ConsentForm);
        }


        let res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/saveMeetingUserData`, MyForm);

        userTmpData.firstName = FirstName;
        userTmpData.lastName = LastName;
        userTmpData.email = Email;
        userTmpData.phoneNo = PhoneNo;
        if (res.data.fileUploadResponse != "") {

            userTmpData.ClinicGroupItem.clinicConsent = res.data.fileUploadResponse.fileName;
        }

        dispatch({
            type: LOGIN_ATTEMPT,
            payload: userTmpData,
        })
        sessionStorage.setItem("UserData", JSON.stringify(userTmpData))
        // dispatch(LoginAction(getState().auth.UserData.email, Password))
        return { status: true, msg: "Profile Updated!" }

    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }
}
export const UpdateProfileImage = (file) => async (dispatch, getState) => {
    try {
        const MyForm = new FormData()
        const userData = getState().auth.UserData;

        MyForm.append("file", file);

        let res = await axios.post(`${getState().utils.baseURL}/PT2/httpdocs/${VERSION_NO}/UpdateDoctorProfilePicture/${userData.adminDocterId}/${getToken(getState)}?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}`, MyForm);

        if (res.data) {
            userData.photo = res.data.photo;
            dispatch({
                type: LOGIN_ATTEMPT,
                payload: userData,
            })
            sessionStorage.setItem("UserData", JSON.stringify(userData))

            return { status: true, msg: "Profile Picture Updated!" }
        }
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }
}



export const GetPermissions = (isPilotOInstituations1, ClinicGroupItem1, ClinicGroupAdminDocterRel1) => async (dispatch, getState) => {

    let isPilotOInstituations = isPilotOInstituations1;
    let ClinicGroupItem = ClinicGroupItem1;
    let ClinicGroupAdminDocterRel = ClinicGroupAdminDocterRel1;

    let showVCL = 0;	// Show Video Consult Link
    let showVCH = 0;	// Show Video Consult Hours
    //if(typeof $sessionStorage.doctorData!='undefined'){
    if (isPilotOInstituations) {
        // Therapist having Pilot/Institution subscription will have full permission
        isPilotOInstituations = 1;
        showVCL = 1;
        showVCH = 1;
        if (ClinicGroupItem.enableVideoConsult == 2 && ClinicGroupAdminDocterRel.isGroupOwner < 2) {
            showVCL = 0;
        } else if (ClinicGroupItem.enableVideoConsult == 0) {
            showVCL = 0;
            showVCH = 0;
        } else if (ClinicGroupItem.enableVideoConsult == 1) {
            if (ClinicGroupItem.itemTypeId == 1 || ClinicGroupItem.itemTypeId == 2) {
                if (ClinicGroupAdminDocterRel.isGroupOwner == 0) {
                    showVCL = 0;
                    showVCH = 0;
                }
            }
        }
    }
    else {
        if (ClinicGroupItem.enableVideoConsult == 1) {
            if (ClinicGroupItem.itemTypeId == 1 || ClinicGroupItem.itemTypeId == 2) {
                if (ClinicGroupAdminDocterRel.isGroupOwner > 0) {
                    showVCL = 1;
                    showVCH = 1;
                }
            }
        }
        else if (ClinicGroupItem.enableVideoConsult == 2) {
            if (ClinicGroupAdminDocterRel.isGroupOwner == 2) {
                showVCL = 1;
                showVCH = 1;
            }
            else if (ClinicGroupAdminDocterRel.isGroupOwner < 2) {
                showVCH = 1;
            }
        }
    }
    //}
    const payload = {
        isPilotOInstituations,
        showVCL,
        showVCH,
    }


    dispatch({
        type: SAVE_PERMISSIONS,
        payload,
    })
}



export const BulkFileUpload = (file) => async (dispatch, getState) => {
    try {

        const MyForm = new FormData()

        MyForm.append("adminDocterId", `${getState().auth.UserData.adminDocterId}`)
        MyForm.append("token", getToken(getState))
        MyForm.append("passcode", getState().auth.UserData.passcodeID1)
        MyForm.append("file", file)


        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PatientBulkUploadViaCsvForMeeting`, MyForm);

        if (res.data.status == 1) {
            return { status: true, msg: "File Uploaded Successfully" }
        }

        return { status: false, msg: "File Not Uploaded!" }



    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}


export const GettingDataForThePatientAddDialog = () => async (dispatch, getState) => {



    try {
        const res1 = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PostFullCountryListForMeeting`,
            {
                "orderby": "Country"
            })

        const res2 = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PostPatientListByTherapistForMeeting`,
            {
                adminDocterId: getState().auth.UserData.adminDocterId,
                clinicGroupItemId: getState().auth.UserData.ClinicGroupItem.clinicGroupItemId,
                fetchAllPatient: 1,
                isGroupOwner: "1",
            })
        let Countries = res1.data;
        let Patients = res2.data;


        dispatch({
            type: DATA_FOR_ADD_PATIENTS,
            payload: { Countries, Patients }
        })
    } catch (error) {
        console.log(error)
    }
}
export const GettingStates = (id) => async (dispatch, getState) => {

    try {
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PostStateListForMeeting`, {
            CountryId: id
        })

        dispatch({
            type: GETTING_STATES,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }



}


export const SaveEditPatient = (
    FirstName,
    LastName,
    CellPhoneNo,
    Email,
    Country,
    State,
    ZipCode,
    Day,
    Month,
    Year,
    EditMode,
    UserId,
    adminDocterUserRelId
) => async (dispatch, getState) => {
    try {


        if (!FirstName) return { status: false, msg: "Please Enter a first name!" }
        if (!LastName) return { status: false, msg: "Please Enter a last name!" }
        if (!CellPhoneNo) return { status: false, msg: "Please Enter a Cell phone number" }
        if (!Country) return { status: false, msg: "Please Select a country" }
        if (Email && !Email.match(/([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)) return { status: false, msg: "Please enter a valid email!" }
        if (!State) return { status: false, msg: "Please Select a State" }
        if (!ZipCode) return { status: false, msg: "Please enter a Zip Code" }
        if (!Month) return { status: false, msg: "Please select a month" }
        if (!Day || Number.isNaN(Day) || Number(Day) < 1 || Number(Day) > 31) return { status: false, msg: "Please enter a valid date" }
        if (!Year || Number.isNaN(Year) || Number(Year) > new Date().getFullYear() || Number(Year) < 1900) return { status: false, msg: "Please enter a valid Year" }

        const body = {
            "passcode": getState().auth.UserData.passcodeID1,
            "token": getToken(getState),
            "docId": getState().auth.UserData.adminDocterId,
            "userId": EditMode ? UserId : "0",
            "patient": {
                "adminDocterId": getState().auth.UserData.adminDocterId,
                "userId": EditMode ? UserId : "0",
                "adminDocterUserRelId": EditMode ? adminDocterUserRelId : "0",
                "firstName": FirstName,
                "lastName": LastName,
                "phoneNo": CellPhoneNo,
                "email": Email,
                "CountryId": Country,
                "stateCode": State,
                "zipcode": ZipCode,
                "birthDate": `${Year}-${Day}-${Month}`
            }
        }


        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PostCreateUpdatePatientForMeeting`, body)
        dispatch(GettingDataForThePatientAddDialog())
        if (res.data.status == 1) return { status: true, msg: EditMode ? "Patient Edited Successfully!" : "Patient Saved Successfully!" }
        if (res.data.status == 3) return { status: false, msg: "Provided phone no is already registered with another patient!" }
        return { status: false, msg: res.data.msg }

    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something Broke" }
    }

}


export const EditPatientGet = (id) => async (dispatch, getState) => {


    try {
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PostUserProfileForMeeting`, {
            "adminDocterId": getState().auth.UserData.adminDocterId,
            "userId": id,
            "passcode": getState().auth.UserData.passcodeID1,
            "token": getToken(getState),
        })


        dispatch({
            type: EDIT_PATIENT,
            payload: res.data[0],
        })


        dispatch(GettingStates(res.data[0].CountryId))
    } catch (error) {
        console.log(error)
    }
}


export const GettingBillingData = (id) => async (dispatch, getState) => {


    axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PostProviderSubscriptionSummaryForMeeting`, {
        adminDocterId: getState().auth.UserData.adminDocterId,
        clinicGroupItemId: getState().auth.UserData.ClinicGroupItem.clinicGroupItemId
    }).then((res) => {
        dispatch({
            type: BILLING_DIALOG_DATA,
            payload: { key: "Subscription", value: res.data }
        })
    }).catch((err) => {
        CustomLogger(err)
    })


    axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PostProviderCardInfoForMeeting`, {
        adminDocterId: getState().auth.UserData.adminDocterId,
    }).then((res) => {
        dispatch({
            type: BILLING_DIALOG_DATA,
            payload: { key: "CardsDetail", value: res.data }
        })
    }).catch((err) => {
        CustomLogger(err)
    })

    axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PostInvoiceHistoryForMeeting`, {
        clinicGroupItemId: getState().auth.UserData.ClinicGroupItem.clinicGroupItemId,
    }).then((res) => {
        dispatch({
            type: BILLING_DIALOG_DATA,
            payload: { key: "InvoiceHistory", value: res.data }
        })
    }).catch((err) => {
        CustomLogger(err)
    })

}



export const VerifyRoomNumber = (RoomNo, toLogin, doctorID, pmID, fromAutoLogin, navigate) => async (dispatch, getState) => {
    try {
        const CheckingUser = sessionStorage.getItem("UserData")
        if (CheckingUser ) {
            if (!getState().meeting.MeetingOn) {
                if(navigate){

                    return navigate("/room")
                }
            }
        }
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/verifyMeetingRoom`, {
            "roomNumb": RoomNo,
            "adminDocterId": getState().auth?.UserData?.adminDocterId || doctorID || 0,
            "isAutoLogin": toLogin ? 1 : 0,
            "pmid": pmID || ""
        })
        if (res.data._data) {
            dispatch({
                type: VERIFY_DATA,
                payload: res.data,
            })
            dispatch({
                type: LOGIN_ATTEMPT,
                payload: res.data._data[0],
            })

            sessionStorage.setItem("UserData", JSON.stringify(res.data._data[0]))


            dispatch({
                type: Actions.SETTING_MEETING_ON,
                payload: true,
            })
            dispatch({
                type: Actions.ENABLE_SOAP,
                payload: true,
            })

            if (!fromAutoLogin) dispatch(Actions.CreatingRoom(RoomNo))

            dispatch({
                type: Actions.STORING_HOST_DATA,
                payload: true
            })


            return true
        }
        dispatch({
            type: VERIFY_DATA,
            payload: res.data,
        })

        if (res.data?.status == 1) {
            return { status: true, data: res.data }
        }
        return { status: false, data: res.data }
    } catch (error) {
        console.log(error)
        return { status: false, data: null }
    }
}

export const CheckRoomStatus = RoomNo => async (dispatch, getState) => {
    if (getState().meeting.MeetingOn) return
    try {
        const res = await axios.get(getMeetingUrl() + "/api/v1/meeting/checkStatus?ID=" + RoomNo)

        if (res.data.MeetingStatus) return true
        if (!res.data.MeetingStatus) return false
    } catch (error) {
        console.log(error)
        return false
    }
}

export const UpdateClinicData = (itemName, address, clinicEmail, clinicPhone, clinicWebsite, logoimg) => async (dispatch, getState) => {
    if (!itemName) return { status: false, msg: "Please Enter Clinic Name" }
    if (!address) return { status: false, msg: "Please Enter Clinic Address" }
    if (!clinicPhone) return { status: false, msg: "Please Enter Clinic Phone" }

    try {
        const MyForm = new FormData()
        const userTmpData = getState().auth.UserData;
        MyForm.append("clinicGroupItemId", `${getState().auth.UserData.features[0].clinicGroupItemId}`);
        MyForm.append("adminDocterId", `${getState().auth.UserData.adminDocterId}`);
        MyForm.append("clinic_name", itemName);
        MyForm.append("clinic_address", address);
        MyForm.append("clinicPhone", clinicPhone);

        userTmpData.ClinicGroupItem.itemName = itemName;
        userTmpData.ClinicGroupItem.address = address;
        userTmpData.ClinicGroupItem.clinicPhone = clinicPhone;

        if (clinicEmail) {
            MyForm.append("clinicEmail", clinicEmail);
            userTmpData.ClinicGroupItem.clinicEmail = clinicEmail;
        }

        if (clinicWebsite) {
            MyForm.append("clinicWebsite", clinicWebsite);
            userTmpData.ClinicGroupItem.clinicWebsite = clinicWebsite;
        }
        MyForm.append("logoimg", "");
        if (logoimg) {
            MyForm.append("logoimg", logoimg);
        }


        let res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/PostSaveClinicForMeeting`, MyForm);
        if (res.data.status == 1) {
            if (res.data.logoimg != '') {
                userTmpData.ClinicGroupItem.logoimg = res.data.logoimg;
            }

            dispatch({
                type: LOGIN_ATTEMPT,
                payload: userTmpData,
            })
            sessionStorage.setItem("UserData", JSON.stringify(userTmpData))

        }
        return { status: true, msg: "Clinic Data Updated!" }

    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}

export const firstTimePayment = () => async (dispatch, getState) => {
  
    try {
        const userData =  getState().auth?.UserData
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/create-checkout-session?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}`, {
            "isFromMeeting": true,
            "docId": userData?.adminDocterId || 0,
        })
       return res;
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}
